export default __webpack_public_path__ + "static/banner-renovation-avoid-common-painting-mistakes-0090bd2e50fd9fa44e6b727c07840ccd.jpg";